import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { generatePath, Navigate } from 'react-router-dom'

import { colours } from '@qflow/theme'
import _ from 'lodash'

import * as ROUTES from 'portal/routes'

import { AccessGrid } from 'portal/components/AccessGrid/AccessGrid'
import { PageContainer } from 'portal/pages/PageContainer'
import { accsGetSaga } from 'portal/store/accounts/actions'
import { projectsClear } from 'portal/store/projects/actions'
import { projectDetailsClear } from 'portal/store/projectDetails/actions'
import { Spinner, Heading, Text } from 'portal/lib/primitives'

import { BodyContainer, BodyInner } from './common'

const Accounts = props => {
  const [redirectToHomepage, setRedirectToHomepage] = useState(false)
  const { onAccountsInit, isLoading, accounts } = props

  useEffect(() => {
    // Clear Session Storage of ProjectId and Module
    sessionStorage.removeItem('last-used-project-id')
    onAccountsInit()
  }, [onAccountsInit])

  useEffect(() => {
    const maybeForwardToAccount = () => {
      if (accounts && accounts.length === 1) {
        setRedirectToHomepage(true)
      }
    }
    maybeForwardToAccount()
  }, [accounts])

  const renderLoading = () => {
    return <Spinner />
  }

  const renderBody = () => {
    if (!accounts || accounts.length === 0) {
      return <Text>No items found!</Text>
    }

    return (
      <BodyContainer>
        <BodyInner>
          <AccessGrid
            avatarBG={colours.CONSTRUCTION_ORANGE}
            items={_(accounts)
              .map(account => {
                return {
                  gridItemId: account.accountId,
                  name: account.name,
                  urlLink: generatePath(ROUTES.REDIRECT_TO_HOMEPAGE, {
                    accountId: account.accountId
                  }),
                  avatar: account.name[0]
                }
              })
              .sortBy(account => account.name.toLowerCase())
              .value()}
          />
        </BodyInner>
      </BodyContainer>
    )
  }

  if (redirectToHomepage && accounts) {
    const accountId = accounts[0].accountId
    return (
      <Navigate
        to={generatePath(ROUTES.REDIRECT_TO_HOMEPAGE, {
          accountId: accountId
        })}
      />
    )
  }

  return (
    <PageContainer
      id="AccountsPage"
      style={{ backgroundColor: colours.CONTROL_PANEL_GREY }}
    >
      <div>
        <Heading>ACCOUNTS</Heading>

        {isLoading ? renderLoading() : renderBody()}
      </div>
    </PageContainer>
  )
}

Accounts.propTypes = {
  onAccountsInit: PropTypes.func,
  isLoading: PropTypes.bool,
  accounts: PropTypes.arrayOf(PropTypes.object),
  history: PropTypes.object,
  match: PropTypes.object
}

const mapStateToProps = state => {
  return {
    accounts: state.accounts.accounts,
    isLoading: state.accounts.isLoading
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onAccountsInit: () => {
      dispatch(projectsClear())
      dispatch(projectDetailsClear())
      dispatch(accsGetSaga())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Accounts)
